import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { updateMeioAnalise, showMeioAnalise, loadMeioAnalises, changeStatus } from '~/store/modules/meio_analise/action';

const Edit = () => {
  let history = useHistory();
  const [editMeioAnalise, setEditMeioAnalise] = useState(initialData);
  const { tipo_licenca_id, id_meio_analise } = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [update, setUpdate] = useState(false);
  const dispatch = useDispatch();
  const { errors, meio_analise } = useSelector(({ MeioAnaliseReducer }) => MeioAnaliseReducer);


  useEffect(() => {
    dispatch(showMeioAnalise(id_meio_analise));
  }, [dispatch, id_meio_analise]);

  useEffect(() => {
    if (meio_analise.id === parseInt(id_meio_analise)) {
      setEditMeioAnalise(meio_analise);
    }
  }, [meio_analise, id_meio_analise]);



  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
  }, [errors]);


  useEffect(() => {
    if (update) {
      Swal.fire('Sucesso', 'Registro atualizado com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadMeioAnalises({
            where:`tipo_licenca_id:${tipo_licenca_id}`,
            with_trashed: true,
          }));
          dispatch(changeStatus(null));
        }
      );
    }
  }, [update, history, dispatch,tipo_licenca_id]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    // console.log('meioAnalise store: ',meioAnalise);
    if (!schema.isValidSync(editMeioAnalise)) {
      console.log('Error meioAnalise store: ',editMeioAnalise);
      let yup_errors = {};
      schema.validate(editMeioAnalise, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const meioAnalise_ = editMeioAnalise;
      meioAnalise_.perguntas_apia_atia = Boolean(parseInt(meioAnalise_.perguntas_apia_atia));
      meioAnalise_.tipo_licenca_id = parseInt(tipo_licenca_id);
      await dispatch(updateMeioAnalise(meioAnalise_, meioAnalise_.id));
      await setUpdate(true);
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Meio analise
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              meioAnalise={editMeioAnalise}
              schema={schema}
              setMeioAnalise={setEditMeioAnalise}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_meioAnalise"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;

